import { defineStyle, defineStyleConfig } from "@chakra-ui/react";

const body1 = defineStyle({
  fontWeight: "400",
  fontSize: "20px",
  lineHeight: "22px",
  // color: "#5B6674",
});

const body2 = defineStyle({
  fontWeight: "400",
  fontSize: "18px",
  lineHeight: "26px",
  // color: "#5B6674",
});

const body3 = defineStyle({
  fontWeight: "400",
  fontSize: "16px",
  lineHeight: "23px",
});

const label1 = defineStyle({
  fontWeight: "500",
  fontSize: "22px",
  lineHeight: "26px",
});

const label2 = defineStyle({
  fontWeight: "400",
  fontSize: "14px",
  lineHeight: "17px",
});

const label3 = defineStyle({
  fontWeight: "400",
  fontSize: "16px",
  lineHeight: "23px",
});

// const caption = defineStyle({
//   fontWeight: "400",
//   fontSize: "12px",
//   lineHeight: "15px",
// });

// const tagline = defineStyle({
//   fontWeight: "400",
//   fontSize: "18px",
//   lineHeight: "18px",
// });

export const Text = defineStyleConfig({
  baseStyle: {},
  sizes: {},
  variants: {
    body1,
    body2,
    body3,
    label1,
    label2,
    label3,
    // caption,
    // tagline,
  },
  defaultProps: {},
});

export const TEXT_VARIANTS = {
  BODY1: "body1",
  BODY2: "body2",
  BODY3: "body3",
  CAPTION: "caption",
  LABEL1: "label1",
  LABEL2: "label2",
  LABEL3: "label3",
  TAGLINE: "tagline",
};
